// Cookie expiration.
// TODO: 'hattuvakio'
const cookieExpirationDate: Date = new Date(2100, 7)

/**
 * Common cookie options maybe.
 * @param {string} p cookie path
 * @returns CookieSetOptions as in React.cookie
 */
export const CommonCookieOptions: (p: string) => { path: string, sameSite: boolean | 'strict' | 'none' | 'lax' | undefined, expires: Date } = (p: string) => {
  return {
    path: p,
    sameSite: 'strict',
    expires: cookieExpirationDate
  }
}
